import type { PaletteOptions } from '@mui/material/styles';

import { brandColors } from './brand';

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: brandColors.primary,
    dark: brandColors.primaryDark,
    light: brandColors.primaryLight,
    contrastText: brandColors.textInverse,
  },
  secondary: {
    main: brandColors.secondary,
    dark: brandColors.secondaryDark,
    light: brandColors.secondaryLight,
    contrastText: brandColors.textPrimary,
  },
  warning: {
    main: brandColors.accent,
    dark: brandColors.accentDark,
    light: brandColors.accentLight,
    contrastText: brandColors.textInverse,
  },
  error: {
    main: brandColors.error,
    contrastText: brandColors.textInverse,
  },
  info: {
    main: brandColors.info,
    contrastText: brandColors.textPrimary,
  },
  success: {
    main: brandColors.success,
    contrastText: brandColors.textInverse,
  },
  text: {
    primary: brandColors.textPrimary,
    secondary: brandColors.textSecondary,
    disabled: brandColors.textDisabled,
  },
  background: {
    default: brandColors.backgroundDefault,
    paper: brandColors.backgroundPaper,
  },
  divider: 'rgba(20, 33, 61, 0.08)',
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: brandColors.primaryLight,
    dark: brandColors.primary,
    light: '#5DEAC8',
    contrastText: '#0B1220',
  },
  secondary: {
    main: brandColors.secondaryLight,
    dark: brandColors.secondary,
    light: '#7AF3E8',
    contrastText: '#0B1220',
  },
  warning: {
    main: brandColors.accentLight,
    dark: brandColors.accent,
    light: '#FFC4A5',
    contrastText: '#0B1220',
  },
  error: {
    main: '#FF6369',
    contrastText: brandColors.textInverse,
  },
  info: {
    main: brandColors.secondaryLight,
    contrastText: '#0B1220',
  },
  success: {
    main: brandColors.primaryLight,
    contrastText: '#0B1220',
  },
  text: {
    primary: brandColors.textInverse,
    secondary: '#B9C2D6',
    disabled: '#6C7791',
  },
  background: {
    default: brandColors.backgroundDefaultDark,
    paper: brandColors.backgroundPaperDark,
  },
  divider: 'rgba(255, 255, 255, 0.08)',
};
